// Экран 6 из ТЗ раздел 3.3: история платежей. Ссылки на чек не показываем — backend их не отдаёт
// (см. app/api/routes/miniapp/payments.py, там же объяснено почему). Список по ВСЕМ подпискам
// пользователя, не только текущей активной — тот же принцип, что и в самом backend-роуте.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ApiError, fetchPayments, type Payment } from "../api/client";

const STATUS_KEYS: Record<Payment["status"], string> = {
  pending: "payment_status_pending",
  succeeded: "payment_status_succeeded",
  failed: "payment_status_failed",
  refunded: "payment_status_refunded",
};

const TYPE_KEYS: Record<Payment["type"], string> = {
  purchase: "payment_type_purchase",
  renewal: "payment_type_renewal",
  upgrade: "payment_type_upgrade",
  refund: "payment_type_refund",
};

export function PaymentsScreen() {
  const { t, i18n } = useTranslation();
  const [payments, setPayments] = useState<Payment[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const dateLocale = i18n.language === "en" ? "en-US" : "ru-RU";

  useEffect(() => {
    let cancelled = false;
    fetchPayments()
      .then((data) => {
        if (!cancelled) setPayments(data);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof ApiError ? err.message : String(err));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <h1>{t("payments_title")}</h1>
      {error && <p role="alert">{t("payments_error")}</p>}
      {!error && payments === null && <p>{t("loading")}</p>}
      {payments !== null && payments.length === 0 && <p>{t("payments_empty")}</p>}
      {payments !== null && payments.length > 0 && (
        <ul>
          {payments.map((payment) => (
            <li key={payment.id}>
              {new Date(payment.created_at).toLocaleDateString(dateLocale)} —{" "}
              {t(TYPE_KEYS[payment.type])}: {payment.amount} {payment.currency} —{" "}
              {t(STATUS_KEYS[payment.status])}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
